import {
  IcreateTenantUserAPIBody,
  IcreateTenantUserAPIResponse,
  IdeleteTenantUserAPIResponse,
  IgetTenantUsersAPIResponse,
  IupdateTenantUserAPIBody,
  IupdateTenantUserAPIResponse,
  IupdateRoleAPIResponse,
} from 'api/endpoints/tenantUsers/tenantUsers.response.interface';
import { getBasePath } from '../../utils/config';
import { safeJsonParse, buildUrl } from 'api/utils/fetchHelpers';

export const getTenantUsersAPI = async ({
  tenantId,
  token,
}: {
  tenantId: string;
  token: string;
}): Promise<IgetTenantUsersAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/get_tenant_users`, { tenant_id: tenantId }),
    params
  );
  return await safeJsonParse(response);
};

export const createTenantUserAPI = async ({
  body,
  token,
}: {
  body: IcreateTenantUserAPIBody;
  token: string;
}): Promise<IcreateTenantUserAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/user/createUser`, params);
  return await safeJsonParse(response);
};

export const updateMainContactAPI = async ({
  body,
  token,
}: {
  body: IupdateTenantUserAPIBody;
  token: string;
}): Promise<IupdateTenantUserAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/user/update_user`, params);
  return await safeJsonParse(response);
};

export const deleteTenantUserAPI = async ({
  userId,
  token,
}: {
  userId: string;
  token: string;
}): Promise<IdeleteTenantUserAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/user/delete_user`, { user_id: userId }),
    params
  );
  return await safeJsonParse(response);
};

export const updateRoleAPI = async ({
  user_id,
  role,
  prev_role,
  token,
}: {
  user_id: string;
  role: string;
  prev_role: string;
  token: string;
}): Promise<IupdateRoleAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id: user_id,
      role: role,
      prev_role: prev_role,
    }),
  };
  const response = await fetch(`${getBasePath()}/user/assign_role`, params);
  return await safeJsonParse(response);
};
